import { Avatar } from "@components/ui/Avatar";
import Icon from "@components/ui/Icon";
import { Rating } from "@components/ui/Rating";
import { t, Trans } from "@helpers/translate";
import { format } from "date-fns";
import React, { FC } from "react";

type Props = {
  displayName: string;
  picture?: string;
  reviewsCount: number;
  rating: number;
  className?: string;
  avatarSize?: "xs" | "sm" | "md" | "lg" | "xl";
  country?: string;
  cityName?: string;
  createdAt?: string;
  showVerifiedData?: boolean;
  onRatingClicked?: () => void;
};

export const User: FC<Props> = ({
  className = "",
  avatarSize = "lg",
  country,
  onRatingClicked,
  showVerifiedData = false,
  ...supplier
}) => {
  const { cityName, displayName } = supplier;
  const alt = `${cityName ? `${cityName} ` : ""}Tour Guide - ${displayName}`;

  return (
    <div className={`flex items-center pb-1 ${className}`}>
      <div className="mr-3">
        <div className="relative">
          <Avatar
            size={showVerifiedData ? "xl" : avatarSize}
            src={supplier.picture}
            alt={alt}
          />
          {showVerifiedData && (
            <div className="absolute -right-1.5 -bottom-0">
              <Icon icon="verifiedGlyph" size="md" />
            </div>
          )}
        </div>
        {showVerifiedData && supplier.createdAt && (
          <p
            className="flex w-full text-xs mt-2 justify-center"
            style={{ color: "#464646" }}
          >
            {t({ id: "supplier.joined", message: "Joined" }) +
              " " +
              format(new Date(supplier.createdAt), "yyyy")}
          </p>
        )}
      </div>
      <div className={showVerifiedData ? "ml-2 -mt-1" : ""}>
        <h2 className="text-secondary text-2xl font-semibold">{displayName}</h2>

        {country && <div className="text-dull_black">{country}</div>}

        {supplier.rating > 0 && supplier.reviewsCount > 0 && (
          <Rating
            rate={supplier.rating}
            reviews={supplier.reviewsCount}
            alwaysShowDecimals={true}
            size="xs"
            onClick={onRatingClicked}
            variant="stars"
          />
        )}

        {showVerifiedData && (
          <div className="flex flex-col md:flex-row mt-1">
            <div className="flex flex-row items-center">
              <Icon icon="checkBlueFilled" size="sm" className="mr-1 w-4" />
              <div
                className="text-gray-500 text-base"
                style={{ color: "#464646" }}
              >
                <Trans id="supplier.identity-verified">Identity Verified</Trans>
              </div>
            </div>
            <div className="flex flex-row md:ml-4">
              <div className="flex">
                <Icon icon="checkBlueFilled" size="sm" className="mr-1 w-4" />
              </div>
              <div
                className="text-gray-500 text-base"
                style={{ color: "#464646" }}
              >
                <Trans id="supplier.interview-based-quality-checks">
                  Interview-Based Quality Checks
                </Trans>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
